import { create } from "zustand";
import { devtools } from "zustand/middleware";

import { TInstallationSelectState, TInstallationSelectStore } from "./InstallationSelect.types";

const initialInstallationSelectState: TInstallationSelectState = {
  installationRef: "",
};

export const useInstallationSelectStore = create<TInstallationSelectStore>()(
  devtools(set => ({
    ...initialInstallationSelectState,
    setInstallationRef: (installationRef: string) => {
      set({
        installationRef,
      });
    },
  })),
);
